import {
    mapTypeOfRepresentatives,
    TypeOfRepresentative,
    TypeOfRepresentativeData,
} from './TypeOfRepresentative'
import { IAddressData, Address } from './Address'
import { IPositionData, mapPositions, Position } from './Position'
import { Contact } from './Contact'

export type ITRhvervMedlemLists = {
    AntalIalt: number
    KortNavn: string
    Medlemsidenter: number[]
    Navn: string
    Sorteringsorden: number
    Type: string
}

export type IWorkplaceData = {
    Navn: string
    ErPrimaertArbejdssted: boolean
    ArbejdsstedType: string | null
    Nummer: number
    OKGruppe: string | null
    Stillingsnummer: string
    Tillidshverv: TypeOfRepresentativeData[]
    Adresse: IAddressData
    Timetal: number
    Stillinger: IPositionData[]
    AntalNoter: number
    TRTillidshvervMedlemLister: ITRhvervMedlemLists[]
}

const getNumberOfMembers = (workPlace: Workplace): number => {
    let numberOfMembers = []

    workPlace.trMemberList.forEach((item) => {
        numberOfMembers = [...numberOfMembers, ...item.Medlemsidenter]
    })

    return Array.from(new Set(numberOfMembers)).length
}

export class Workplace {
    name = ''

    isPrimaryWorkplace = false

    type: string | null = null

    okGroup: string | null = null

    number = 0

    postionNumber = ''

    typeOfRepresentatives: TypeOfRepresentative[] = []

    address: Address | undefined

    hoursPerWeek = 0

    positions: Position[]

    contact: Contact | undefined

    numberOfNotes = 0

    trMemberList: ITRhvervMedlemLists[] = []

    numberOfMembers = 0

    // Searchables.
    searchable_name = ''

    searchable_address = ''

    public static build = (data: IWorkplaceData): Workplace => {
        const workPlace = new Workplace()

        workPlace.name = data.Navn || ''
        workPlace.address = data.Adresse && Address.build(data.Adresse)
        workPlace.isPrimaryWorkplace = data.ErPrimaertArbejdssted
        workPlace.type = data.ArbejdsstedType
        workPlace.number = data.Nummer
        workPlace.okGroup = data.OKGruppe
        workPlace.postionNumber = data.Stillingsnummer
        workPlace.hoursPerWeek = data.Timetal || 0
        workPlace.typeOfRepresentatives = mapTypeOfRepresentatives(
            data.Tillidshverv
        )

        if (data.Stillinger) {
            workPlace.positions = mapPositions(data.Stillinger)
        }

        workPlace.numberOfNotes = data.AntalNoter || 0

        workPlace.trMemberList = data.TRTillidshvervMedlemLister || []

        if (workPlace.trMemberList && workPlace.trMemberList.length) {
            workPlace.numberOfMembers = getNumberOfMembers(workPlace)
        }

        /**
         * Searchables.
         */

        workPlace.searchable_name = workPlace.name

        workPlace.searchable_address = workPlace.address
            ? `${workPlace.address.addressLine1} ${workPlace.address.postDistrict} ${workPlace.address.postNumber}`
            : ''

        return workPlace
    }
}

export function mapWorkplaces(data: IWorkplaceData[]): Workplace[] {
    return data && data.map((workplace) => Workplace.build(workplace))
}

export function attachContactInfo(workPlace: Workplace, data: any): Workplace {
    const wp = { ...workPlace }
    const found = data.KontaktoplysningerList.find((item) => {
        return (
            item.KontaktoplysningerForArbejdssted !== null &&
            item.KontaktoplysningerForArbejdssted.Nummer === workPlace.number
        )
    })

    if (found) {
        wp.contact = Contact.build(found)
    }

    return wp
}
